// TODO - remove lint disable when editing this file
/* eslint-disable */
import { createReducer } from 'redux-ramda'
import { always, pipe, applySpec, prop, flip, merge, assoc, path } from 'ramda'
import { createAction } from 'redux-actions'
import { ACTION_INIT } from './commonActions'

export const ACTION_ROUTE_CHANGING = 'ellipsis.route.changing'
export const routeChangingAction = createAction(ACTION_ROUTE_CHANGING)

export const ACTION_ROUTE_CHANGED = 'ellipsis.route.changed'
export const routeChangedAction = createAction(ACTION_ROUTE_CHANGED)

const initialState = {
  // Current route
  current: '',
  // Previous route
  from: '',
  // Parameters from the URL
  parameters: {},
  // Route change in progress
  changing: false,
}

export default createReducer(initialState, [
  [ACTION_INIT, () => always(initialState)],
  [
    ACTION_ROUTE_CHANGING,
    pipe(
      applySpec({
        current: prop('current'),
        from: prop('from'),
        parameters: prop('params'),
        changing: always(true),
      }),
      flip(merge)
    ),
  ],
  [ACTION_ROUTE_CHANGED, () => assoc('changing', false)],
])

export const hasStoryIdAssigned = (state) => {
  const { route: { current = '', parameters = {} } = {} } = state || {}
  const storyEditingRoute = ['/story/', '/edit/'].some(
    (part) => ~current.indexOf(part)
  )
  if (!storyEditingRoute) {
    return false
  }
  return !!parameters.id
}
export const getCurrentRoute = path(['route', 'current'])
